"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreditRepay = exports.useCreateLedger = exports.useFetchTbpBillAmount = exports.useFetchLatestLedgerEntry = exports.useFetchAllLedgerEntry = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const ledgerAction_1 = require("./ledgerAction");
const useFetchAllLedgerEntry = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchAllLedgerEntryLoading = (0, react_redux_1.useSelector)((state) => state['ledger/fetchAllLedgerEntry'].loading);
    const fetchAllLedgerEntryError = (0, react_redux_1.useSelector)((state) => state['ledger/fetchAllLedgerEntry'].error);
    const fetchAllLedgerEntryData = (0, react_redux_1.useSelector)((state) => state['ledger/fetchAllLedgerEntry'].data);
    const fetchAllLedgerEntryHook = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('auth/sign-in');
            return;
        }
        yield dispatch((0, ledgerAction_1.fetchAllLedgerEntry)(payload));
    });
    return {
        fetchAllLedgerEntryLoading,
        fetchAllLedgerEntryError,
        fetchAllLedgerEntryData,
        fetchAllLedgerEntryHook
    };
};
exports.useFetchAllLedgerEntry = useFetchAllLedgerEntry;
const useFetchLatestLedgerEntry = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchLatestLedgerEntryLoading = (0, react_redux_1.useSelector)((state) => state['ledger/fetchLatestLedgerEntry'].loading);
    const fetchLatestLedgerEntryError = (0, react_redux_1.useSelector)((state) => state['ledger/fetchLatestLedgerEntry'].error);
    const fetchLatestLedgerEntryData = (0, react_redux_1.useSelector)((state) => state['ledger/fetchLatestLedgerEntry'].data);
    const fetchLatestLedgerEntryHook = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('auth/sign-in');
            return;
        }
        yield dispatch((0, ledgerAction_1.fetchLatestLedgerEntry)(payload));
    });
    return {
        fetchLatestLedgerEntryLoading,
        fetchLatestLedgerEntryError,
        fetchLatestLedgerEntryData,
        fetchLatestLedgerEntryHook
    };
};
exports.useFetchLatestLedgerEntry = useFetchLatestLedgerEntry;
const useFetchTbpBillAmount = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchTbpBillAmountLoading = (0, react_redux_1.useSelector)((state) => state['ledger/fetchTbpBillAmount'].loading);
    const fetchTbpBillAmountError = (0, react_redux_1.useSelector)((state) => state['ledger/fetchTbpBillAmount'].error);
    const fetchTbpBillAmountData = (0, react_redux_1.useSelector)((state) => state['ledger/fetchTbpBillAmount'].data);
    const fetchTbpBillAmountHook = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('auth/sign-in');
            return;
        }
        yield dispatch((0, ledgerAction_1.fetchTbpBillAmount)(payload));
    });
    return {
        fetchTbpBillAmountLoading,
        fetchTbpBillAmountError,
        fetchTbpBillAmountData,
        fetchTbpBillAmountHook
    };
};
exports.useFetchTbpBillAmount = useFetchTbpBillAmount;
const useCreateLedger = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createLedgerLoading = (0, react_redux_1.useSelector)((state) => state['ledger/create'].loading);
    const createLedgerError = (0, react_redux_1.useSelector)((state) => state['ledger/create'].error);
    const createLedgerData = (0, react_redux_1.useSelector)((state) => state['ledger/create'].data);
    const createLedger = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('auth/sign-in');
                return;
            }
            const res = yield dispatch((0, ledgerAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error while creating ledger entry');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createLedgerLoading,
        createLedgerError,
        createLedgerData,
        createLedger
    };
};
exports.useCreateLedger = useCreateLedger;
const useCreditRepay = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const creditRepayLoading = (0, react_redux_1.useSelector)((state) => state['ledger/creditRepay'].loading);
    const creditRepayError = (0, react_redux_1.useSelector)((state) => state['ledger/creditRepay'].error);
    const creditRepayData = (0, react_redux_1.useSelector)((state) => state['ledger/creditRepay'].data);
    const creditRepayHook = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('auth/sign-in');
                return;
            }
            const res = yield dispatch((0, ledgerAction_1.creditRepay)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error while creating ledger entry');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        creditRepayLoading,
        creditRepayError,
        creditRepayData,
        creditRepayHook
    };
};
exports.useCreditRepay = useCreditRepay;
